module.exports = __webpack_public_path__ + "static/img/tips.991ad71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page/tips.png
// module id = OR6W
// module chunks = 53